let _scopeCounter = 0;

export function getAdminSelectCSS(tk, prefix) {
  const scope = `${prefix}-${++_scopeCounter}`;
  return {
    scope,
    css: `
      .${scope} {
        height: 34px; padding: 0 28px 0 10px;
        background-color: ${tk.surface} !important;
        color: ${tk.textSecondary} !important;
        border: 1px solid ${tk.border};
        border-radius: 8px; font-family: inherit; font-size: 12px; font-weight: 500;
        cursor: pointer; outline: none; appearance: none; -webkit-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%238a8a96' stroke-width='2' viewBox='0 0 24 24'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
        background-repeat: no-repeat; background-position: right 8px center;
      }
      .${scope}[data-active="true"] {
        background-color: ${tk.accentSoft} !important;
        color: ${tk.accentText} !important;
        border-color: ${tk.accent};
      }
      .${scope} option {
        background-color: ${tk.surface} !important;
        color: ${tk.text} !important;
      }
    `,
    className: (active) => `${scope}`,
    dataActive: (active) => active ? 'true' : 'false',
  };
}

export function getAdminFormSelectCSS(tk, prefix) {
  const scope = `${prefix}-${++_scopeCounter}`;
  return {
    scope,
    css: `
      .${scope} {
        width: 100%; height: 40px; padding: 0 28px 0 12px;
        background-color: ${tk.sunken} !important;
        color: ${tk.text} !important;
        border: 1px solid ${tk.border}; border-radius: 8px;
        font-family: inherit; font-size: 13px; outline: none; cursor: pointer;
        appearance: none; -webkit-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%238a8a96' stroke-width='2' viewBox='0 0 24 24'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
        background-repeat: no-repeat; background-position: right 8px center;
        box-sizing: border-box;
      }
      .${scope} option {
        background-color: ${tk.surface} !important;
        color: ${tk.text} !important;
      }
    `,
    className: scope,
  };
}

export function getAdminFieldSelectCSS(tk, prefix) {
  const scope = `${prefix}-${++_scopeCounter}`;
  return {
    scope,
    css: `
      .${scope} {
        width: 100%; height: 36px; padding: 0 28px 0 12px;
        background-color: ${tk.surfaceAlt} !important;
        color: ${tk.text} !important;
        border: 1px solid ${tk.border}; border-radius: 7px;
        font-family: inherit; font-size: 12.5px; outline: none; cursor: pointer;
        appearance: none; -webkit-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%238a8a96' stroke-width='2' viewBox='0 0 24 24'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
        background-repeat: no-repeat; background-position: right 10px center;
        box-sizing: border-box;
      }
      .${scope} option {
        background-color: ${tk.surface} !important;
        color: ${tk.text} !important;
      }
    `,
    className: scope,
  };
}
